import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentRow from '../components/ContentRow';

const BrowseContainer = styled.div`
  min-height: 100vh;
  background-color: #141414;
  padding-top: 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  padding: 0 4%;
  color: white;

  @media (max-width: 768px) {
    font-size: 2rem;
    padding: 0 20px;
    margin-bottom: 1.5rem;
  }
`;

const Browse = () => {
  const { categories } = useSelector(state => state.content);

  const browseRows = [
    {
      title: 'All Movies & TV Shows',
      contentIds: [...categories.movies, ...categories.tvShows]
    },
    {
      title: 'Movies',
      contentIds: categories.movies
    },
    {
      title: 'TV Shows',
      contentIds: categories.tvShows
    },
    {
      title: 'Action & Adventure',
      contentIds: categories.action
    },
    {
      title: 'Dramas',
      contentIds: categories.drama
    },
    {
      title: 'Crime Thrillers',
      contentIds: categories.crime
    },
    {
      title: 'Sci-Fi',
      contentIds: categories.sciFi
    },
    {
      title: 'New & Popular',
      contentIds: categories.newReleases
    }
  ];

  return (
    <BrowseContainer>
      <PageTitle>Browse</PageTitle>

      {browseRows.map((row, index) => (
        <ContentRow
          key={row.title}
          title={row.title}
          contentIds={row.contentIds}
          rowIndex={index}
        />
      ))}
    </BrowseContainer>
  );
};

export default Browse;